export const ANALYTICS_VENDORS = ['mixpanel', 'ga'];

const PAYMENT_PAGE_EVENTS = {
    PP_LOADED: "pp-loaded",
    PP_EXPIRED: "pp-expired",
    PP_CUSTOM_FORM_LOADED: "pp-custom-form-loaded",
    // PP_CUSTOM_FORM_FILL_MOBILE_NUMBER: "pp-custom-form-fill-mobile-number",
    PP_CUSTOM_FORM_SKIP_MOBILE_NUMBER: "pp-custom-form-skip-mobile-number",
    PP_CUSTOM_FORM_SKIP_MOBILE_VERIFICATION: "pp-custom-form-skip-mobile-verification",
    PP_CUSTOM_FORM_SEND_OTP: "pp-custom-form-send-otp",
    PP_CUSTOM_FORM_SKIP_OTP: "pp-custom-form-skip-otp",
    PP_CUSTOM_FORM_VERIFY_OTP_SUCCESS: "pp-custom-form-verify-otp-success",
    PP_CUSTOM_FORM_VERIFY_OTP_FAIL: "pp-custom-form-verify-otp-fail",
    // PP_CUSTOM_FORM_RESEND_OTP: "pp-custom-form-resend-otp",
    PP_CUSTOM_FORM_SUBMITTED: "pp-custom-form-submitted",
    PP_SKIP_CUSTOM_FORM: "pp-skip-custom-form",
    PP_FEE_HEADER_SELECTION_LOADED: "pp-fee-header-selection-loaded",
    PP_FEE_HEADER_SELECTION_SUBMITTED: "pp-fee-header-selection-submitted",
    PP_SKIP_FEE_HEADER_SELECTION: "pp-skip-fee-header-selection",
    PP_CARDS_LOADED: "pp-cards-loaded",
    PP_CARDS_SELECTED: "pp-cards-selected",
    //
    PP_PROCEED_PAYMENT: "pp-proceed-payment",
    PP_FILL_MOBILE_NUMBER: "pp-fill-mobile-number",
    PP_SKIP_MOBILE_NUMBER: "pp-skip-mobile-number",
}

const HELP_PAGE_EVENTS = {
    PP_REDIRECT_HELP_PAGE: "pp-redirect-help-page",
    // PP_HELP_PAGE_LOADED: "pp-help-page-loaded",
}

const RECEIPT_PAGE_EVENTS = {
    PP_REDIRECT_RCPT_PAGE: "pp-redirect-rcpt-page",
    PP_RCPT_FILL_MOBILE_NUMBER: "pp-rcpt-fill-mobile-number",
    // PP_RCPT_SKIP_MOBILE_VERIFICATION: "pp-rcpt-skip-mobile-verification",
    PP_RCPT_SEND_OTP: "pp-rcpt-send-otp",
    PP_RCPT_VERIFY_OTP_SUCCESS: "pp-rcpt-verify-otp-success",
    PP_RCPT_VERIFY_OTP_FAIL: "pp-rcpt-verify-otp-fail",
    // PP_RCPT_RESEND_OTP: "pp-rcpt-resend-otp",
    PP_RCPT_DOWNLOAD_PAGE: "pp-rcpt-download-page",
    PP_RCPT_DOWNLOAD: "pp-rcpt-download",
}

const SEARCH_PAGE_EVENTS = {
    PP_SEARCH_PAGE_LOADED: "pp-search-page-loaded",
    PP_SEARCH_PAGE_REDIRECT: "pp-search-page-redirect",
}

const STATIC_PAGE_EVENTS = {
    PP_STATIC_PAGE_LOADED: "pp-static-page-loaded",
    PP_STATIC_PAGE_REDIRECT: "pp-static-page-redirect",
}

const WORKFLOW_PAGE_EVENTS = {
    PP_WORKFLOW_PAY_CARD_SELECTED: "pp-workflow-pay-card-selected",
    PP_WORKFLOW_COMMIT_CARD_SELECTED: "pp-workflow-commit-card-selected",
    PP_WORKFLOW_PAY_CARD_SUCCESS: "pp-workflow-pay-card-success",
    PP_WORKFLOW_PAY_CARD_FAIL: "pp-workflow-pay-card-fail",
    PP_WORKFLOW_COMMIT_CARD_SUCCESS: "pp-workflow-commit-card-success",
    PP_WORKFLOW_COMMIT_CARD_FAIL: "pp-workflow-commit-card-fail",
    PP_WORKFLOW_PAGE_LOADED: "pp-workflow-page-loaded",
    // PP_WORKFLOW_PAY_CARD_UPDATE_SUCCESS: "pp-workflow-pay-card-update-success",
    // PP_WORKFLOW_PAY_CARD_UPDATE_FAIL: "pp-workflow-pay-card-update-fail",
    // PP_WORKFLOW_COMMIT_CARD_UPDATE_SUCCESS: "pp-workflow-commit-card-update-success",
    // PP_WORKFLOW_COMMIT_CARD_UPDATE_FAIL: "pp-workflow-commit-card-update-fail",
}

const DYNAMIC_FH_PAGE_EVENTS = {
    PP_DYNAMIC_PAGE_LOADED: "pp-dynamic-page-loaded",
    PP_DYNAMIC_PAGE_FORM_LOADED: "pp-dynamic-page-form-loaded",
    PP_DYNAMIC_PAGE_FORM_SUBMITTED: "pp-dynamic-page-form-submitted",
    PP_DYNAMIC_PAGE_DYN_FT_NOT_AVAILABLE: "pp-dynamic-page-dynamic-ft-not-available"
}

const PP_API_EVENTS = {
    PP_FETCH_PAGE_API: {
        SUCCESS: "pp-fetch-api-success",
        FAILED: "pp-fetch-api-failed"
    },
    PP_STUD_WRAPPER_API: {
        SUCCESS: "pp-student-wrapper-api-success",
        FAILED: "pp-student-wrapper-api-failed",
    }
}

export const ANALYTICS_EVENTS = {
    ...PAYMENT_PAGE_EVENTS,
    ...HELP_PAGE_EVENTS,
    ...RECEIPT_PAGE_EVENTS,
    ...SEARCH_PAGE_EVENTS,
    ...STATIC_PAGE_EVENTS,
    ...WORKFLOW_PAGE_EVENTS,
    ...DYNAMIC_FH_PAGE_EVENTS,
    ...PP_API_EVENTS,
}